import {
  CompanyDto,
  CompanyType,
  CreateCompanyCommand,
  UpdateCompanyCommand,
} from '@billing/app/api'
import { CompanyFormProfile } from './company-form.profile'

const mapFormValuesToCreateDto = ({
  name,
  shortName,
  alternativeNames,
  companyTypes,
  email,
  phoneNumber,
  remarks,
  taxId,
  isDeactivated,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
}: CompanyFormProfile): CreateCompanyCommand => ({
  name,
  shortName,
  alternativeNames: alternativeNames.filter(x => x.trim() !== ''),
  companyTypes: companyTypes as CompanyType[],
  email,
  phoneNumber,
  remarks,
  taxId,
  isDeactivated,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
})

const mapFormValuesToUpdateDto = ({
  id,
  name,
  shortName,
  alternativeNames,
  companyTypes,
  email,
  phoneNumber,
  remarks,
  taxId,
  isDeactivated,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
}: CompanyFormProfile): UpdateCompanyCommand => ({
  id: id!,
  name,
  shortName,
  alternativeNames: alternativeNames.filter(x => x.trim() !== ''),
  companyTypes: companyTypes as CompanyType[],
  email,
  phoneNumber,
  remarks,
  taxId,
  isDeactivated,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
})

const mapDtoToFormValues = ({
  id,
  name,
  shortName,
  alternativeNames,
  companyTypes,
  email,
  phoneNumber,
  remarks,
  taxId,
  isDeactivated,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
}: CompanyDto): CompanyFormProfile => ({
  id,
  name,
  shortName,
  companyTypes,
  alternativeNames: alternativeNames,
  email: email ?? '',
  phoneNumber: phoneNumber ?? '',
  remarks: remarks ?? '',
  taxId: taxId ?? '',
  isDeactivated: isDeactivated ?? false,
  addressLine1,
  addressLine2,
  city,
  postalCode,
  country,
  accountInfo,
})

export const CompanyFormMapper = {
  mapFormValuesToCreateDto,
  mapFormValuesToUpdateDto,
  mapDtoToFormValues,
}
